// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hris-list-page {
  padding: 8px 0 36px;
}

.hris-list-page .page-header {
  margin-bottom: 18px !important;
}

.hris-list-page .page-title {
  color: #1f2b3d;
  font-size: 22px;
  font-weight: 750;
  letter-spacing: 0;
}

.hris-list-page .page-header .btn {
  min-height: 40px;
  border-radius: 5px !important;
  padding: 0 14px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.hris-list-card {
  border: 1px solid #e1e9ef;
  border-radius: 7px;
  box-shadow: 0 2px 9px rgba(41, 73, 102, 0.035);
  overflow: hidden;
}

.hris-list-card .card-body {
  padding: 0;
}

.hris-list-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid #e5edf2;
}

.hris-list-heading h3 {
  margin: 0;
  color: #2d3b4d;
  font-size: 17px;
  font-weight: 750;
}

.hris-list-heading p {
  margin: 4px 0 0;
  color: #7c8ea2;
  font-size: 13px;
}

.hris-list-card .row.align-items-center.w-full {
  margin: 0;
  padding: 16px 22px;
  border-bottom: 1px solid #eaf0f4;
}

.hris-table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  width: 100%;
}

.hris-table-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.hris-list-page .hris-filter-button,
.hris-list-page .hris-table-actions .btn,
.hris-list-page .hris-table-actions button {
  min-height: 38px;
  border-radius: 5px;
  font-weight: 650;
}

.hris-list-page .table-responsive {
  margin-top: 0 !important;
  overflow-x: auto;
  scrollbar-gutter: stable;
}

.hris-list-page .table {
  margin-bottom: 0;
  min-width: 1040px;
}

.hris-list-page .table thead th {
  padding: 13px 16px;
  background: #f6f8fa;
  border-bottom: 1px solid #e3ebf1;
  color: #718098;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: .06em;
  text-transform: uppercase;
  vertical-align: middle;
}

.hris-list-page .table tbody td {
  padding: 14px 16px;
  border-bottom: 1px solid #eaf0f4;
  color: #3b4656;
  font-size: 13px;
  vertical-align: middle;
  white-space: normal;
}

.hris-list-page .table tbody tr:hover {
  background: #f8fbfc;
}

.hris-list-page .table .badge {
  min-width: 64px;
  border-radius: 5px;
  padding: 6px 9px;
  font-weight: 750;
}

.hris-list-page .btn-ghost-secondary {
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 5px;
  color: #65758a;
}

.hris-list-page .btn-list {
  justify-content: flex-end;
  gap: 6px;
}

.hris-list-page .btn-list a {
  width: 30px;
  height: 30px;
  display: inline-grid;
  place-items: center;
  border: 1px solid #dce5ec;
  border-radius: 5px;
  background: #fff;
  color: #168094;
}

.hris-list-page .btn-list a:hover {
  background: #f4fbfc;
  border-color: #a8d7df;
}

.hris-list-page .btn-list svg {
  width: 16px;
  height: 16px;
}

.hris-list-page .table-responsive + .d-flex {
  margin: 0 !important;
  padding: 14px 22px;
  border-top: 1px solid #eaf0f4;
  color: #75859a;
}

.hris-expanded-panel {
  margin: 0;
  padding: 16px 18px 18px 74px;
  background: #fbfdfe;
  border-top: 1px solid #eaf0f4;
}

.hris-expanded-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.hris-expanded-header span {
  display: block;
  color: #7b8ba0;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.hris-expanded-header strong {
  display: block;
  margin-top: 3px;
  color: #2d3b4d;
  font-size: 14px;
}

.hris-expanded-count {
  border-radius: 999px;
  background: #eaf7f6;
  color: #237a85 !important;
  padding: 5px 9px;
  text-transform: none !important;
  letter-spacing: 0 !important;
}

.hris-expanded-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.hris-role-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e1e9ef;
  border-radius: 6px;
  background: #fff;
}

.hris-role-card strong {
  display: block;
  color: #2d3b4d;
  font-size: 13px;
}

.hris-role-card span {
  display: block;
  margin-top: 2px;
  color: #8998aa;
  font-size: 11px;
}

.hris-role-count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 44px;
  justify-content: center;
  border-radius: 999px;
  background: #eef4f7;
  color: #4c6278;
  padding: 5px 8px;
  font-weight: 750;
}

.hris-expanded-empty {
  padding: 18px;
  border: 1px dashed #dce5ec;
  border-radius: 6px;
  color: #8795a8;
  text-align: center;
}

@media (max-width: 920px) {
  .hris-list-page .page-header .row,
  .hris-table-toolbar,
  .hris-table-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .hris-list-page .page-header .col-auto,
  .hris-table-actions,
  .hris-table-actions > * {
    width: 100%;
  }

  .hris-expanded-panel {
    padding-left: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HRIS/HRISListPage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".hris-list-page {\n  padding: 8px 0 36px;\n}\n\n.hris-list-page .page-header {\n  margin-bottom: 18px !important;\n}\n\n.hris-list-page .page-title {\n  color: #1f2b3d;\n  font-size: 22px;\n  font-weight: 750;\n  letter-spacing: 0;\n}\n\n.hris-list-page .page-header .btn {\n  min-height: 40px;\n  border-radius: 5px !important;\n  padding: 0 14px !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.hris-list-card {\n  border: 1px solid #e1e9ef;\n  border-radius: 7px;\n  box-shadow: 0 2px 9px rgba(41, 73, 102, 0.035);\n  overflow: hidden;\n}\n\n.hris-list-card .card-body {\n  padding: 0;\n}\n\n.hris-list-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 22px 16px;\n  border-bottom: 1px solid #e5edf2;\n}\n\n.hris-list-heading h3 {\n  margin: 0;\n  color: #2d3b4d;\n  font-size: 17px;\n  font-weight: 750;\n}\n\n.hris-list-heading p {\n  margin: 4px 0 0;\n  color: #7c8ea2;\n  font-size: 13px;\n}\n\n.hris-list-card .row.align-items-center.w-full {\n  margin: 0;\n  padding: 16px 22px;\n  border-bottom: 1px solid #eaf0f4;\n}\n\n.hris-table-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  width: 100%;\n}\n\n.hris-table-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.hris-list-page .hris-filter-button,\n.hris-list-page .hris-table-actions .btn,\n.hris-list-page .hris-table-actions button {\n  min-height: 38px;\n  border-radius: 5px;\n  font-weight: 650;\n}\n\n.hris-list-page .table-responsive {\n  margin-top: 0 !important;\n  overflow-x: auto;\n  scrollbar-gutter: stable;\n}\n\n.hris-list-page .table {\n  margin-bottom: 0;\n  min-width: 1040px;\n}\n\n.hris-list-page .table thead th {\n  padding: 13px 16px;\n  background: #f6f8fa;\n  border-bottom: 1px solid #e3ebf1;\n  color: #718098;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: .06em;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n\n.hris-list-page .table tbody td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #eaf0f4;\n  color: #3b4656;\n  font-size: 13px;\n  vertical-align: middle;\n  white-space: normal;\n}\n\n.hris-list-page .table tbody tr:hover {\n  background: #f8fbfc;\n}\n\n.hris-list-page .table .badge {\n  min-width: 64px;\n  border-radius: 5px;\n  padding: 6px 9px;\n  font-weight: 750;\n}\n\n.hris-list-page .btn-ghost-secondary {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border-radius: 5px;\n  color: #65758a;\n}\n\n.hris-list-page .btn-list {\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.hris-list-page .btn-list a {\n  width: 30px;\n  height: 30px;\n  display: inline-grid;\n  place-items: center;\n  border: 1px solid #dce5ec;\n  border-radius: 5px;\n  background: #fff;\n  color: #168094;\n}\n\n.hris-list-page .btn-list a:hover {\n  background: #f4fbfc;\n  border-color: #a8d7df;\n}\n\n.hris-list-page .btn-list svg {\n  width: 16px;\n  height: 16px;\n}\n\n.hris-list-page .table-responsive + .d-flex {\n  margin: 0 !important;\n  padding: 14px 22px;\n  border-top: 1px solid #eaf0f4;\n  color: #75859a;\n}\n\n.hris-expanded-panel {\n  margin: 0;\n  padding: 16px 18px 18px 74px;\n  background: #fbfdfe;\n  border-top: 1px solid #eaf0f4;\n}\n\n.hris-expanded-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.hris-expanded-header span {\n  display: block;\n  color: #7b8ba0;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: .06em;\n  text-transform: uppercase;\n}\n\n.hris-expanded-header strong {\n  display: block;\n  margin-top: 3px;\n  color: #2d3b4d;\n  font-size: 14px;\n}\n\n.hris-expanded-count {\n  border-radius: 999px;\n  background: #eaf7f6;\n  color: #237a85 !important;\n  padding: 5px 9px;\n  text-transform: none !important;\n  letter-spacing: 0 !important;\n}\n\n.hris-expanded-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 10px;\n}\n\n.hris-role-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid #e1e9ef;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.hris-role-card strong {\n  display: block;\n  color: #2d3b4d;\n  font-size: 13px;\n}\n\n.hris-role-card span {\n  display: block;\n  margin-top: 2px;\n  color: #8998aa;\n  font-size: 11px;\n}\n\n.hris-role-count {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 44px;\n  justify-content: center;\n  border-radius: 999px;\n  background: #eef4f7;\n  color: #4c6278;\n  padding: 5px 8px;\n  font-weight: 750;\n}\n\n.hris-expanded-empty {\n  padding: 18px;\n  border: 1px dashed #dce5ec;\n  border-radius: 6px;\n  color: #8795a8;\n  text-align: center;\n}\n\n@media (max-width: 920px) {\n  .hris-list-page .page-header .row,\n  .hris-table-toolbar,\n  .hris-table-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .hris-list-page .page-header .col-auto,\n  .hris-table-actions,\n  .hris-table-actions > * {\n    width: 100%;\n  }\n\n  .hris-expanded-panel {\n    padding-left: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
